module.exports = {
	"articleTitle1": "The view from Ann Arbor: Skeeps abuzz with Harbaugh hype ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Scorekeepers (Skeeps)",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/about-campus",
	"articleSnippet1": "Sep 3, 2015 ... Michigan fans watch Michigan football coach Jim Harbaugh's first game as head \ncoach at Scorekeepers Bar in Ann Arbor on Thursday.",
	"articleSnippet2": "Nov 14, 2007 ... At the entrances of Scorekeepers, The Brown Jug and Conor O'Neills, doormen \nlike Bell are in the best position to perceive trends and ...",
	"foodRecommendations": [],
	"articleTitle2": "About campus",
	"address": "310 Maynard St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150903/IMG_18352.jpg?itok=kVeMHT0U",
			"author": "Jennifer Calfas",
			"caption": "Michigan fans watch Michigan football coach Jim Harbaugh's first game as head coach at Scorekeepers Bar in Ann Arbor on Thursday"
		}
	],
	"position": {
		"lat": 42.278813,
		"lng": -83.742369
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/skeeps.json
// module id = 972
// module chunks = 0